import { forwardRef } from "react";
import { getAppDeepLinkUrlHashId } from "@/utils/url";
import { jumpToAppStore } from "@/utils/tenjin";
import { useTrack } from "@/hooks/useTrack";
import { TrackingPoints } from "../../points";
import TopBarSkeleton from "./skeleton";
import "./index.scss";

const classPrefix = "yfm-product-detail-top-bar";

interface TopBarProps {
  isSkeleton: boolean;
  hashId: string;
  productId?: string;
}

const TopBar = forwardRef<HTMLDivElement, TopBarProps>(
  ({ isSkeleton, hashId, productId }, ref) => {
    const { tracking } = useTrack();

    const downloadYooFinds = () => {
      tracking({
        ...TrackingPoints.Download,
        product_id: productId,
      });
      jumpToAppStore(getAppDeepLinkUrlHashId(hashId));
    };

    if (isSkeleton) return <TopBarSkeleton />;

    return (
      <div ref={ref} className={classPrefix}>
        <div
          ref={ref}
          className={`${classPrefix}__container yfm-app-page-width-fix`}
        >
          Earn above public commissions by downloading <br />
          YooFinds!{" "}
          <span className={`${classPrefix}__link`} onClick={downloadYooFinds}>
            Download Now &gt;&gt;
          </span>
        </div>
      </div>
    );
  }
);

TopBar.displayName = "BottomBar";

export default TopBar;
